import React,{ useEffect, useState } from 'react'
import { getDocs } from 'firebase/firestore'
import {portfolioRef} from '../../Firebase/collections'
import './Portfolio.css'
import Loading from '../Loading/Loading'

function Portfolio() {
  const [folioInfo,setFolioInfo] = useState([])
  const [currentImage,setCurrentImage] = useState()
  const [loadingScreen,setLoadingScreen] = useState(true)

  useEffect(() => {
    let filterId = window.location.pathname.slice(11,undefined)
    getDocs(portfolioRef).then(snap => {
      snap.docs.map(doc => {
        if(filterId === doc.id) {
          const useData = doc.data()
          setCurrentImage([useData.image])
          setLoadingScreen(false)
          setFolioInfo([useData])
        }
      })
    })
  }, [])
  
  return (
    <div className='portfolio'>
      {loadingScreen ?<Loading/>:null}
      {
        folioInfo.map(({name,image,discription,image2,image3,image4,image5,link},index) => {
          return(
          <div className="portfolio-container" key={index}>
          <div className='top'>
          <div className="image-container">
              <div className="left">
                <img src={currentImage} alt="landingImage" />
              </div>
              <div className="right">
                <img onClick={() => setCurrentImage(image)} src={image} alt="landingImage" />
                <img onClick={() => setCurrentImage(image2)} src={image2} alt="image2" />
                <img onClick={() => setCurrentImage(image3)} src={image3} alt="image3" />
                <img onClick={() => setCurrentImage(image4)} src={image4} alt="image4" />
                <img onClick={() => setCurrentImage(image5)} src={image5} alt="image5" />
              </div>
            </div>
        </div>
        <div className="bottom">
            <h1>{name}</h1>
            <p>{discription}</p>
            <button><a href={link}>Download</a></button>
        </div>
      </div>
          )
        })
      }
    </div>
  )
}

export default Portfolio